<template>
	<div>
		<el-breadcrumb-item>
			<span style="font-weight: bold;" v-if="levelList.length<=1">{{levelList[0].meta.title}}</span>
			<span style="font-weight: bold;" v-else>{{levelList[levelList.length-2].meta.title}}</span>
		</el-breadcrumb-item>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				levelList: null
			};
		},
		watch: {
			$route(route) {
				this.getBreadcrumb()
			}
		},
		created() {
			this.getBreadcrumb()
		},
		methods: {
			getBreadcrumb() {
				//取出当前路由的   matched（包含当前路由的所有嵌套路径片段）
				let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
				const first = matched[0]
				if (!this.isDashboard(first)) {
					matched = [{
						path: '/welcome',
						meta: {
							title: '首页'
						}
					}].concat(matched)
				}
				this.levelList = matched;
			},
			isDashboard(route) {
				const name = route && route.name
				if (!name) {
					return false
				}
				return name.trim() === '首页'
			}
		}


	}
</script>

<style>
</style>
